// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import type { GenerativeAiAgentIdCopyTargetAppGroupIdResult } from "./types";

export const isGenerativeAiAgentIdCopyTargetAppGroupIdResult =
  objectOf<GenerativeAiAgentIdCopyTargetAppGroupIdResult>({
    agent_id: string,
    app_group_id: string,
    source_agent_id: string,
    source_app_group_id: string,
    model_fallback_applied: boolean,
  });
